import type { CMSConfig } from '#types/config/components/cms'
import type { RecursivePartial } from '#types/utils'

export default {
  allowMixBlendMode: false
} satisfies RecursivePartial<CMSConfig['promoBar']>
